import { CoffeeToGoOutlineIcon } from './CoffeeToGoOutlineIcon';

/**
 * author: Simran
 * id DC66752A-65C6-461D-AAA6-65E8389E7D3B
 * name coffee-to-go-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-to-go-outline.svg
 * tags
 * - Food / Drink 
 */
export const CupToGoOutlineIcon = CoffeeToGoOutlineIcon;
export default CupToGoOutlineIcon